import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import ButtonView from '@ckeditor/ckeditor5-ui/src/button/buttonview';
import Icon from './customButtonCommentSearchIcon.svg';

export class customButtonCommentSearch extends Plugin {
  init() {
    const editor = this.editor;

    // このプラグイン用の設定を取得
    // getIsOpen: ダイアログが表示されているかどうかを取得する関数
    // setIsOpen: ダイアログの表示状態をセットする関数。
    // setUpdateButtonFunction: このボタンの更新が必要なときに呼ばれる関数をセットする関数。
    const config = editor.config.get('commentSearch');
    if (config) {
      const getIsOpen = config.getIsOpen;
      const setIsOpen = config.setIsOpen;
      const setIsEnabled = config.setIsEnabled;
      const setUpdateButtonFunction = config.setUpdateButtonFunction;
      if (getIsOpen && setIsOpen) {
        editor.ui.componentFactory.add('customButtonCommentSearch', () => {
          const button = new ButtonView();

          button.set({
            label: editor.i18n.t('コメント検索'),
            icon: Icon,
            withText: true,
          });

          /**
           * 初期状態をセット。
           */
          button.isOn = getIsOpen();

          /**
           * ボタンが押されたときの動作を記述。
           */
          button.on('execute', () => {
            // ダイアログの表示状態を取得
            const isOpen = getIsOpen();

            setIsOpen(!isOpen);

            button.isOn = !isOpen;
          });

          /**
           * 更新が必要な時のための関数をセット。
           */
          if (setUpdateButtonFunction) {
            setUpdateButtonFunction((isOn) => {
              // ボタンがオンかどうかを設定
              button.isOn = isOn;
            });
          }

          /**
           * 権限による有効/無効制御
           */
          button.isEnabled = setIsEnabled;

          return button;
        });
      }
    }
  }
}
